const API_BASE = process.env.REACT_APP_API_URL || '';

function getToken() {
  // sessionStorage hat Vorrang (Impersonation-Tab), dann localStorage (normale Session)
  return sessionStorage.getItem('access_token') || localStorage.getItem('access_token');
}

async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE}${path}`, { cache: 'no-store', ...options, headers });

  if (res.status === 401) {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('is_impersonating');
    localStorage.removeItem('access_token');
    window.location.replace('/login');
    return;
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }

  if (res.status === 204) return null;
  return res.json();
}

export default apiFetch;
